module.exports = __webpack_public_path__ + "static/media/26UNRWA21.8c328736.jpg";